<template>
    <button 
        type="button" 
        class="btn btn-sm btn-outline-theme"
        :disabled="isLoading"
        @click="downloadProperties"
    >
        <span v-if="isLoading">
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Exporting...
        </span>
        <span v-else>
            <i class="bi bi-download me-1"></i>
            Export Properties
        </span>
    </button>
</template>

<script>
export default {
    name: 'DownloadPropertiesButton',
    props: {
        exportRoute: {
            type: String,
            required: true
        },
        userId: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            isLoading: false
        };
    },
    methods: {
        async downloadProperties() {
            this.isLoading = true;
            
            try {
                // Build URL with user_id param if provided
                let exportUrl = this.exportRoute;
                if (this.userId) {
                    exportUrl += (exportUrl.includes('?') ? '&' : '?') + 'user_id=' + this.userId;
                }
                
                const response = await axios.get(exportUrl, {
                    responseType: 'blob',
                    timeout: 300000 // 5 minutes timeout for large exports
                });
                
                // Create download link
                const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = blobUrl;
                
                // Generate filename with date
                const date = new Date().toISOString().split('T')[0];
                link.setAttribute('download', `properties-export-${date}.csv`);
                
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                
                // Clean up
                window.URL.revokeObjectURL(blobUrl);
                
            } catch (error) {
                console.error('Export failed:', error);
                alert('Failed to export properties. Please try again.');
            } finally {
                this.isLoading = false;
            }
        }
    }
}
</script>
